import { isEqual } from 'lodash/fp'
import { connect } from 'react-redux'

import { getCurrentApp } from 'e-submission/apps/selectors'
import validator from 'e-submission/domain/data-model/form/validation'

const options = {
  areStatePropsEqual: isEqual,
}

function EncValidation(Component) {
  return connect(
    (state, { value, required, id }) => {
      const { getValidationMessages } = validator(id)
      return getValidationMessages({
        value,
        required,
        app: getCurrentApp(state),
        state,
      })
    },
    null,
    null,
    options
  )(function EncComponent(props) {
    const { id, setValue } = props

    let _setValue = setValue
    const { allow } = validator(id)
    if (allow) {
      _setValue = (nextValue) => {
        if (allow(nextValue)) {
          return setValue(nextValue)
        }
      }
    }
    return <Component {...props} setValue={_setValue} allow={allow} />
  })
}

export default EncValidation
